import { render, staticRenderFns } from "./TicketHistoryDetail-Component.vue?vue&type=template&id=41b72992"
import script from "./TicketHistoryDetail-Component.vue?vue&type=script&lang=js"
export * from "./TicketHistoryDetail-Component.vue?vue&type=script&lang=js"
import style0 from "./TicketHistoryDetail-Component.vue?vue&type=style&index=0&id=41b72992&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports